<template>
  <div class="home-page">
    <top-section />
    <top-section-logos />
    <why-section />
    <hr class="separate-line">
    <producing-section />
    <hr class="separate-line">
    <packaging-section />
    <hr class="separate-line">
    <shipping-section />
    <certified-section />
    <locations-section />
    <stats-section />
    <contact-us-section />
    <app-footer />
  </div>
</template>

<script>
import TopSection from '../TopSection'
import TopSectionLogos from '../TopSectionLogos'
import ProducingSection from '../ProducingSection'
import PackagingSection from '../PackagingSection'
import ShippingSection from '../ShippingSection'
import CertifiedSection from '../CertifiedSection'
import LocationsSection from '../LocationsSection'
import WhySection from '../WhySection'
import StatsSection from '../StatsSection'
import ContactUsSection from '../ContactUsSection'
import AppFooter from '../AppFooter'

export default {
  name: 'HomePage',
  components: {
    TopSection,
    TopSectionLogos,
    ProducingSection,
    PackagingSection,
    ShippingSection,
    CertifiedSection,
    LocationsSection,
    WhySection,
    StatsSection,
    ContactUsSection,
    AppFooter,
  },
}
</script>

<style lang="sass" scoped>
.home-page
  padding-top: 76px
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue